module.exports = __webpack_public_path__ + "static/media/pm.85556bea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pm.svg
// module id = 225
// module chunks = 0